// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getRemoteConfig } from "firebase/remote-config";
import { fetchAndActivate, getValue } from "firebase/remote-config";

const firebaseMotelConfig = {
  apiKey: "AIzaSyBVvTGgaVolX-Q49qsp6fm68wu_i1qWjAM",
  authDomain: "ohya-motel.firebaseapp.com",
  projectId: "ohya-motel",
  storageBucket: "ohya-motel.appspot.com",
  messagingSenderId: "650005101983",
  appId: "1:650005101983:web:c7a276c2800749533411aa",
  measurementId: "G-Y14NWR5EWM",
};

const appMotel = initializeApp(firebaseMotelConfig, "ohyaMotelFirebase");

const analyticsMotel = getAnalytics(appMotel);

const remoteMotelConfig = getRemoteConfig(appMotel);

remoteMotelConfig.settings.minimumFetchIntervalMillis = 3600000;

fetchAndActivate(remoteMotelConfig);

const getNoticeValue = async () => {
  try {
    await fetchAndActivate(remoteMotelConfig);
    const noticeValue = getValue(remoteMotelConfig, "getNotice").asString();
    const noticeValueObject = JSON.parse(noticeValue);
    // console.log(noticeValueObject["info"]);
    return noticeValueObject;
  } catch (error) {
    console.error("Failed to fetch and activate remote config:", error);
    return null;
  }
};

export { appMotel, analyticsMotel, remoteMotelConfig, getNoticeValue };
